// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import './ProgressBar.css';

export interface ProgressBarProps {
  percent: number;
  color?: 'purple' | 'green' | 'blue' | 'red';
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  showPercent?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export function ProgressBar({
  percent,
  color = 'purple',
  size = 'md',
  label,
  showPercent = false,
  className = '',
  style,
}: ProgressBarProps) {
  const clampedPercent = Math.min(100, Math.max(0, percent));

  const classes = [
    'fin-progress',
    `fin-progress--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} style={style}>
      <div className="fin-progress__bar" role="progressbar" aria-valuenow={clampedPercent} aria-valuemin={0} aria-valuemax={100}>
        <div
          className={['fin-progress__fill', `fin-progress__fill--${color}`].join(' ')}
          style={{ width: `${clampedPercent}%` }}
        />
      </div>
      {(label || showPercent) && (
        <div className="fin-progress__label">
          {label && <span>{label}</span>}
          {showPercent && <span>{clampedPercent}%</span>}
        </div>
      )}
    </div>
  );
}
